import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';


import localeDe from '@angular/common/locales/de';
import localeDeExtra from '@angular/common/locales/extra/de';
import localeItExtra from '@angular/common/locales/extra/it';
import localeIt from '@angular/common/locales/it';


import { HTTP_INTERCEPTORS, HttpClient, HttpClientModule } from '@angular/common/http';

import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatIconModule } from '@angular/material/icon';

import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { LocalizedDatePipe } from './_pipe/localizedDate.pipe';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { Step1Component } from './step1/step1.component';


import { CommonModule, registerLocaleData } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatMomentDateModule } from '@angular/material-moment-adapter';
import { DialogPromoComponent } from './_dialoghi/dialog-promo/dialog-promo.component';
import { LoaderInterceptor } from './_interceptor/loader.interceptor';
import { LoaderComponent } from './_loader/loader/loader.component';
import { LocalizedDurataPipe } from './_pipe/localizedDurata.pipe';
import { Step2Component } from './step2/step2.component';

import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';

import { RiepilogoPrenotazioneComponent } from './riepilogo-prenotazione/riepilogo-prenotazione.component';
import { StepPagaZeroComponent } from './step-paga-zero/step-paga-zero.component';
import { Step3Component } from './step3/step3.component';
import { StripeComponent } from './stripe/stripe.component';
import { ViniInclusiComponent } from './vini-components/sotto-componenti/vini-inclusi/vini-inclusi.component';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatRadioModule } from '@angular/material/radio';
import { MatDialogModule } from '@angular/material/dialog';
import { MatInputModule } from '@angular/material/input';
import { TipiVisiteComponent } from './tipi-visite-components/tipi-visite/tipi-visite.component';
import { TipiVisiteLayoutBaseComponent } from './tipi-visite-components/tipi-visite-layout-base/tipi-visite-layout-base.component';
import { TipologieComponent } from './_utility/tipologie/tipologie.component';
import { DettaglioTipovisitaComponent } from './tipi-visite-components/sotto-componenti/dettaglio-tipovisita/dettaglio-tipovisita.component';
import { TipologieTipovisitaComponent } from './_utility/tipologie-tipovisita/tipologie-tipovisita.component';
import { TestoEspandibileComponent } from './_utility/testo-espandibile/testo-espandibile.component';
import { TipivisitaLayoutColonneComponent } from './tipi-visite-components/tipi-visite-layout-colonne/tipi-visite-layout-colonne.component';
import { ViniVendibiliComponent } from './vini-components/vini-vendibili/vini-vendibili.component';
import { DettaglioVinoComponent } from './vini-components/sotto-componenti/dettaglio-vino/dettaglio-vino.component';
import { TagsVinoComponent } from './vini-components/sotto-componenti/tags-vino/tags-vino.component';
import { SpecificheVinoComponent } from './vini-components/sotto-componenti/specifiche-vino/specifiche-vino.component';
import { AcquistoVinoComponent } from './vini-components/acquisto-vino/acquisto-vino.component';
import { DialogPromoViniComponent } from './_dialoghi/dialog-promo-vini/dialog-promo-vini.component';
import { ViniVendibiliHeaderComponent } from './vini-components/sotto-componenti/vini-vendibili-header/vini-vendibili-header.component';
import { WarningComponent } from './_utility/warning/warning.component';
import { LastStepTipovisitaComponent } from './tipi-visite-components/sotto-componenti/last-step-tipovisita/last-step-tipovisita.component';
import { ViniVendibiliLayoutBaseComponent } from './vini-components/vini-vendibili-layout-base/vini-vendibili-layout-base.component';
import { ViniVendibiliLayoutColonneComponent } from './vini-components/vini-vendibili-layout-colonne/vini-vendibili-layout-colonne.component';
import { CaricamentoComponent } from './_utility/caricamento/caricamento.component';
import { FooterComponent } from './_utility/footer/footer.component';
import { CarrelloItemsComponent } from './_utility/carrello-items/carrello-items.component';
import { CarrelloComponent } from './_utility/carrello/carrello.component';
import { PacchettiVendibiliLayoutBaseComponent } from './vini-components/pacchetti-vendibili-layout-base/pacchetti-vendibili-layout-base.component';
import { DettaglioPacchettoComponent } from './vini-components/sotto-componenti/dettaglio-pacchetto/dettaglio-pacchetto.component';
import { AcquistoPacchettoComponent } from './vini-components/acquisto-pacchetto/acquisto-pacchetto.component';
import { CollegateComponent } from './collegate/collegate.component';
import { DisabilitatoComponent } from './_utility/disabilitato/disabilitato.component';
import { NessunRisultatoComponent } from './_utility/nessun-risultato/nessun-risultato.component';
import { RecensioniComponent } from './recensioni_cantina/recensioni/recensioni.component';
import { PunteggioRecensioniComponent } from './recensioni_cantina/punteggio-recensioni/punteggio-recensioni.component';
import { ViniBaseComponent } from './vini-components/vini-base/vini-base.component';
import { LastStepBuonocantinaComponent } from './tipi-visite-components/sotto-componenti/last-step-buonocantina/last-step-buonocantina.component';
import { Step1RegaloComponent } from './step1-regalo/step1-regalo.component';
import { NoteTerminiComponent } from './_utility/note-termini/note-termini.component';
import { Step1LoadingComponent } from './step1-loading/step1-loading.component';
import { FaqComponent } from './recensioni_cantina/faq/faq.component';
import { DialogScontoCarrelloAlertComponent } from './_dialoghi/dialog-sconto-carrello-alert/dialog-sconto-carrello-alert.component';
import { DialogCarrelloPienoComponent } from './_dialoghi/dialog-carrello-pieno/dialog-carrello-pieno.component';
import { FormSpedizioneComponent } from './forms/form-spedizione/form-spedizione.component';
import { AssociataBoxComponent } from './_utility/associata-box/associata-box.component';
import { CaricamentoViniComponent } from './_utility/caricamento-vini/caricamento-vini.component';
import { Step1VinoComponent } from './step1-vino/step1-vino.component';
import { CaricamentoVisiteComponent } from './_utility/caricamento-visite/caricamento-visite.component';
import { PannelloInfoComponent } from './_utility/pannello-info/pannello-info.component';

import { PaginatorModule } from 'primeng/paginator';
import { SezioniTipiVisiteComponent } from './tipi-visite-components/sezioni-tipi-visite/sezioni-tipi-visite.component';

registerLocaleData(localeIt, 'it', localeItExtra);
registerLocaleData(localeDe, 'de', localeDeExtra);

@NgModule({
  declarations: [
    AppComponent,
    Step1Component,
    LocalizedDatePipe,
    LocalizedDurataPipe,
    LoaderComponent,
    DialogPromoComponent,
    Step2Component,
    StripeComponent,
    Step3Component,
    StepPagaZeroComponent,
    RiepilogoPrenotazioneComponent,
    ViniInclusiComponent,
    TipiVisiteComponent,
    TipiVisiteLayoutBaseComponent,
    TipologieComponent,
    DettaglioTipovisitaComponent,
    TipologieTipovisitaComponent,
    TestoEspandibileComponent,
    TipivisitaLayoutColonneComponent,
    ViniVendibiliComponent,
    ViniVendibiliLayoutBaseComponent,
    ViniVendibiliLayoutColonneComponent,
    DettaglioVinoComponent,
    TagsVinoComponent,
    SpecificheVinoComponent,
    AcquistoVinoComponent,
    DialogPromoViniComponent,
    ViniVendibiliHeaderComponent,
    WarningComponent,
    LastStepTipovisitaComponent,
    CaricamentoComponent,
    FooterComponent,
    CarrelloItemsComponent,
    CarrelloComponent,
    PacchettiVendibiliLayoutBaseComponent,
    DettaglioPacchettoComponent,
    AcquistoPacchettoComponent,
    CollegateComponent,
    DisabilitatoComponent,
    NessunRisultatoComponent,
    RecensioniComponent,
    PunteggioRecensioniComponent,
    ViniBaseComponent,
    LastStepBuonocantinaComponent,
    Step1RegaloComponent,
    NoteTerminiComponent,
    Step1LoadingComponent,
    FaqComponent,
    DialogScontoCarrelloAlertComponent,
    DialogCarrelloPienoComponent,
    FormSpedizioneComponent,
    AssociataBoxComponent,
    CaricamentoViniComponent,
    Step1VinoComponent,
    CaricamentoVisiteComponent,
    PannelloInfoComponent,
    SezioniTipiVisiteComponent
  ],
  imports: [
    CommonModule,
    BrowserAnimationsModule,
    BrowserModule,
    AppRoutingModule,
    HttpClientModule,
    TranslateModule.forRoot({
      defaultLanguage: 'it',
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      }
    }),
    BrowserAnimationsModule,
    ReactiveFormsModule,
    FormsModule,
    MatIconModule,
    MatMomentDateModule,
    MatDatepickerModule,
    MatFormFieldModule,
    MatSelectModule,
    MatTooltipModule,
    MatInputModule,
    MatProgressSpinnerModule,
    MatProgressBarModule,
    MatExpansionModule,
    MatCheckboxModule,
    MatRadioModule,
    MatDialogModule,
    MatAutocompleteModule,
    PaginatorModule
  ],
  providers: [
    LocalizedDatePipe,
    LocalizedDurataPipe,
    { provide: HTTP_INTERCEPTORS, useClass: LoaderInterceptor, multi: true },
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/');
}
